import currencyFormatter from './currency-formatter'

export default currencyFormatter
